import { Component, Input, OnChanges } from '@angular/core';

import { BDCPProductDetails } from '../../../../models/product-details.model';

@Component({
    selector: 'bdcp-product-image-viewer',
    templateUrl: './product-image-viewer.component.html',
    styleUrls: ['./product-image-viewer.component.scss']
})
export class BDCPProductImageViewerComponent implements OnChanges {

    @Input() public product: BDCPProductDetails;

    public presentImageIndex: number;
    public presentImageSource: string;

    public ngOnChanges(): void {
        this.presentImageIndex = 0;
        this.presentImageSource = this.product?.images?.[0] || ''
    }

    public clicked(index: number): void {
        this.presentImageIndex = index;
        this.presentImageSource = this.product?.images[this.presentImageIndex];
    }

    onImageError(event: Event): void {
      const target = event.target as HTMLImageElement;
      target.src = 'assets/images/product_img_dummy.png';
    }
}
